<div class="modal fade" id="rateSetModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1">
	<div class="modal-dialog">
		<div class="modal-content">
			<div class="modal-header">
				<button type="button" class="btn-close" (click)="dialogClose()"></button>
			</div>
			<form>
				<div class="modal-body">
					<div class="container">
						<div class="mb-3">
							<div class="row g-2">
								<div class="form-floating col-md">
									<input
										type="date"
										class="form-control"
										name="dateFrom"
										id="dateFrom"
										[(ngModel)]="data.dateFrom"
										[readonly]="isItemBefore"
									/>
									<label for="dateFrom">Data od</label>
								</div>
								<div class="form-floating col-md">
									<input
										type="date"
										class="form-control"
										name="dateTo"
										id="dateTo"
										[(ngModel)]="data.dateTo"
										[readonly]="isItemAfter"
									/>
									<label for="dateTo">Data do</label>
								</div>
							</div>
						</div>
						<div class="mb-3">
							<div class="btn-group w-100" role="group">
								<input
									type="radio"
									class="btn-check"
									name="periodType"
									id="periodTypeRate"
									[value]="1"
									[(ngModel)]="data.periodType"
								/>
								<label class="btn btn-outline-primary" for="periodTypeRate">Stawka</label>
								<input
									type="radio"
									class="btn-check"
									name="periodType"
									id="periodTypeMonthly"
									[value]="2"
									[(ngModel)]="data.periodType"
								/>
								<label class="btn btn-outline-primary" for="periodTypeMonthly"
									>Wypłata miesięczna</label
								>
							</div>
						</div>
						@if (data.periodType === 1) {
							<div class="mb-3">
								<div class="row g-2">
									<div class="form-floating col-md">
										<input
											type="number"
											class="form-control"
											name="workRate"
											id="workRate"
											[(ngModel)]="data.workRate"
										/>
										<label for="workRate">Jezdna</label>
									</div>
									<div class="form-floating col-md">
										<input
											type="number"
											class="form-control"
											name="breakRate"
											id="breakRate"
											[(ngModel)]="data.breakRate"
										/>
										<label for="breakRate">Leżona</label>
									</div>
									<div class="form-floating col-md">
										<input
											type="number"
											class="form-control"
											name="otherRate"
											id="otherRate"
											[(ngModel)]="data.otherRate"
										/>
										<label for="otherRate">Inna</label>
									</div>
								</div>
							</div>
						} @else {
							<div class="mb-3">
								<div class="form-floating">
									<input
										type="number"
										class="form-control"
										name="monthlyAmount"
										id="monthlyAmount"
										[(ngModel)]="data.monthlyAmount"
									/>
									<label for="monthlyAmount">Kwota miesięczna (PLN)</label>
								</div>
							</div>
						}
					</div>
				</div>
			</form>
			<div class="modal-footer">
				<div class="container">
					<div class="row">
						<div class="col-sm text-end">
							<div class="btn btn-primary me-2" (click)="submit()">Zapisz</div>
							<div class="btn btn-secondary" data-bs-dismiss="modal" (click)="dialogClose()">Anuluj</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<app-dynamic-table
	[tableRows]="tableRows"
	[elements]="tableElements"
	[haveAnyFilters]="false"
	[haveLink]="false"
	[haveButton]="true"
	(buttonClicked)="setRate($event)"
>
</app-dynamic-table>
